import { Component,Input } from '@angular/core';
import { Meta } from '../../../../models/Meta';
@Component({
  selector: 'app-tabla-meta',
  templateUrl: './tabla-meta.component.html',
  styleUrls: ['./tabla-meta.component.scss']
})
export class TablaMetaComponent   {
  @Input() Data : Meta = new Meta();

 // Data2 :Meta[] = [];


  // displayedColumns: string[] = ['idArea','MontoProyectado','FechaInicio','FechaFin'];
  // dataSource: any = new MatTableDataSource(); 

  


}
